import dayjs, { Dayjs } from "dayjs";

export const getLast7DaysRange = (now: Dayjs = dayjs()): [Dayjs, Dayjs] => [
    now.subtract(6, "day").startOf("day"),
    now.startOf("day"),
];
